module.exports = __webpack_public_path__ + "static/media/image1.100c1bd4.jpg";